<template>
  <v-container grid-list-xs>
    <v-container>
      <!-- Seccion: REGISTRAR -->
      <v-row>
        <v-col md="12">
          <v-card>
            <v-card-title>Registar o Modificar menu</v-card-title>
            <v-card-text>
              <v-row>
                <!-- form: nombre -->
                <v-col md="4">
                  <v-text-field
                    prepend-icon="mdi-clipboard-list"
                    label="Nombre"
                    v-model="menu.nombre"
                  ></v-text-field>
                </v-col>

                <!-- form: Componente -->
                <v-col md="4" v-if="!espadre">
                  <v-text-field
                    prepend-icon="mdi-clipboard-list"
                    label="Componente"
                    v-model="menu.componente"
                  ></v-text-field>
                </v-col>

                <!-- form: ruta -->
                <v-col md="4">
                  <v-text-field prepend-icon="mdi-account" label="Ruta" v-model="menu.ruta"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <!-- form: check es padre -->
                <v-col md="4">
                  <v-checkbox v-model="espadre" label="Es Padre" @change="checkEsPadre"></v-checkbox>
                </v-col>

                <!-- form: listado de padres -->
                <v-col md="4" v-if="!espadre">
                  <v-select
                    v-model="menu.menupadreid"
                    :items="listamenupadre"
                    item-text="nombre"
                    item-value="menuId"
                    label="Seleccione menu padre"
                    @change="obtenerUltimoOrden"
                  ></v-select>
                </v-col>

                <!-- form: orden -->
                <v-col md="4">
                  <v-text-field
                    prepend-icon="mdi-numeric"
                    label="Orden"
                    v-model="menu.orden"
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <!-- form: icono -->
                <v-col md="4">
                  <v-text-field :prepend-icon="menu.icono" label="Icono" v-model="menu.icono"></v-text-field>
                </v-col>

                <!-- form: color -->
                <v-col md="4">
                  <v-text-field
                    prepend-icon="mdi-palette"
                    label="Color"
                    v-model="menu.color"
                    type="color"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn @click="limpiarForm()">Cancelar</v-btn>
              <v-btn @click="guardarCambios()">guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Seccion: Listado -->
      <v-row>
        <v-col md="12">
          <v-card>
            <v-card-title primary-title>Listado de Menu</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-group
                  v-for="item in tablalistadomenu.filter(x => x.menupadreId == 0)"
                  :key="item.menuId"
                  :prepend-icon="item.icono"
                  :color="item.color"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.nombre"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon small>
                        <v-icon small class="mr-2" @click="obtenerObjetoParaEditar(item)">mdi-pencil</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-btn icon small>
                        <v-icon small @click="eliminarMenu(item.menuId)">mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </template>

                  <v-list-item
                    v-for="subitem in tablalistadomenu.filter(x => x.menupadreId == item.menuId)"
                    :key="subitem.menuId"
                    :prepend-icon="subitem.icono"
                    :color="subitem.color"
                  >
                    <v-list-item-icon class="pl-5">
                      <v-icon v-text="subitem.icono"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="subitem.nombre"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon small>
                        <v-icon
                          small
                          class="mr-2"
                          @click="obtenerObjetoParaEditar(subitem)"
                        >mdi-pencil</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-btn icon small>
                        <v-icon small @click="eliminarMenu(subitem.menuId)">mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import Menuservice from "../../services/Menu.service";
import Perfilservice from "../../services/Perfil.service";

export default {
  data() {
    return {
      menu: {
        menuid: null,
        nombre: "",
        componente: "",
        ruta: "",
        menupadreid: null,
        orden: null,
        icono: "",
        color: "",
      },
      listamenupadre: [],
      espadre: false,
      tablalistadomenu: [],
    };
  },
  methods: {
    cargarMenuPadre() {
      Menuservice.ObtenerMenuPadre().then((res) => {
        this.listamenupadre = res.data;
      });
    },
    cargarTablaMenu() {
      Menuservice.ObtenerTodo().then((res) => {
        this.tablalistadomenu = res.data;
      });
    },
    async guardarCambios() {
      var res = await confirm("¿Desea guardar el menu?");
      if (res) {
        this.menu.orden = +this.menu.orden;
        if (this.menu.menuid == null) {
          Menuservice.Insertar(this.menu).then((res) => {
            this.limpiarForm();
            this.cargarTablaMenu();
          });
        } else {
          Menuservice.Editar(this.menu).then((res) => {
            this.limpiarForm();
            this.cargarTablaMenu();
          });
        }
      }
    },
    checkEsPadre() {
      if (this.espadre) {
        this.obtenerUltimoOrden(0);
        this.menu.componente = "";
      }
    },
    obtenerUltimoOrden(id) {
      Menuservice.ObtenerUltimoOrden(id).then((res) => {
        this.menu.orden = res.data;
      });
    },
    obtenerObjetoParaEditar(item) {
      this.menu = {
        menuid: item.menuId,
        nombre: item.nombre,
        componente: item.componente,
        ruta: item.ruta,
        menupadreid: item.menupadreId,
        orden: item.orden,
        icono: item.icono,
        color: item.color,
      };
      if (this.menu.menupadreid == 0) {
        this.espadre = true;
      }
    },
    limpiarForm() {
      this.menu = {
        menuid: null,
        nombre: "",
        componente: "",
        ruta: "",
        menupadreid: null,
        orden: null,
        icono: "",
        color: "",
      };
      this.espadre = false;
    },
    async eliminarMenu(menuid) {
      var res = await confirm("¿Desea eliminar el menu?");
      if (res) {
        Menuservice.Eliminar(menuid).then((res) => {
          this.cargarTablaMenu();
        });
      }
    },
  },
  mounted() {
    this.cargarMenuPadre();
    this.cargarTablaMenu();
  },
};
</script>